import React from 'react'
import {useDispatch} from 'react-redux'
import {useMediaQuery} from '@mui/material'
import styled from 'styled-components'
import IconButtonAtom from '../../to_forms/icon_button/icon_button.atom'
import {hideModal} from '../../../store_redux/reducer/modal.reducer'
import modal_headerStyles from './modal_header.styles'

interface ModalHeaderAtomProps {
  showBackButton: boolean
  ap_type: 'book_date_modal'
}

const apAtomName = {ap_atom_name: 'apModalHeaderAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${modal_headerStyles}
`

const ModalHeaderAtom: React.FC<Partial<ModalHeaderAtomProps>> = function ({
  children,
  showBackButton,
  ap_type,
}) {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(max-width:501px)')

  const closeModal = () => {
    dispatch(hideModal())
  }

  return (
    <StyledWrapper {...apAtomName} ap_type={ap_type}>
      {matches && showBackButton && (
        <IconButtonAtom ap_type="arrowBack" onClick={closeModal} />
      )}
      {children}
    </StyledWrapper>
  )
}

ModalHeaderAtom.defaultProps = {
  // eslint-disable-next-line
  showBackButton: true,
}

export default ModalHeaderAtom
